import { useState } from 'react';
import { Header } from './features/header/Header.js';
import { Hero } from './features/hero/Hero.js';
import { PainPoints } from './features/problem/PainPoints.js';
import { Solutions } from './features/solution/Solutions.js';
import { Architecture } from './features/architecture/Architecture.js';
import { FeatureMatrix } from './features/matrix/FeatureMatrix.js';
import { RoiCalculator } from './features/roi/RoiCalculator.js';
import { Faq } from './features/faq/Faq.js';
import { Footer } from './features/footer/Footer.js';
import { LeadFormModal } from './features/lead/components/LeadFormModal.js';
import { Button } from './components/Button.js';
import { ArrowRight, ShieldCheck, FileText } from 'lucide-react';

export function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalSource, setModalSource] = useState('landing_page');

  const handleOpenModal = (source: string) => {
    setModalSource(source);
    setIsModalOpen(true);
  };

  return (
    <div className="min-h-screen bg-slate-50 text-slate-800 flex flex-col selection:bg-emerald-500/20 selection:text-emerald-900">
      {/* Global Header */}
      <Header onOpenLeadModal={handleOpenModal} />

      {/* Main Sections */}
      <main className="flex-grow">
        <Hero onOpenLeadModal={handleOpenModal} />
        <PainPoints />
        <Solutions />
        <Architecture />
        <FeatureMatrix />
        <RoiCalculator onOpenLeadModal={handleOpenModal} />
        <Faq />

        {/* Final CTA Banner (爽やかなライトグラデーション) */}
        <section className="py-20 md:py-28 relative overflow-hidden bg-gradient-to-b from-slate-50 via-emerald-50/40 to-teal-50/60 border-t border-slate-200">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
            <div className="inline-flex p-3.5 rounded-2xl bg-white border border-emerald-200 text-emerald-600 mb-6 shadow-sm">
              <ShieldCheck className="w-8 h-8" />
            </div>
            <h2 className="text-3xl sm:text-5xl font-extrabold text-slate-900 mb-6 tracking-tight leading-tight">
              企業のデジタル資産を、不可侵の聖域へ。
            </h2>
            <p className="text-base sm:text-lg text-slate-600 max-w-2xl mx-auto mb-10 leading-relaxed">
              Google Workspace の標準機能だけでは防ぎきれない特権管理者侵害・ランサムウェアへの防衛と、
              退職者アカウント整理による直接的なコスト削減を、最短1日でスタートできます。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Button
                variant="primary"
                size="lg"
                className="w-full sm:w-auto px-8 py-4 text-base shadow-lg shadow-emerald-600/20"
                icon={<ArrowRight className="w-5 h-5" />}
                onClick={() => handleOpenModal('bottom_cta_poc')}
              >
                無料PoC・デモ相談を予約する
              </Button>
              <Button
                variant="secondary"
                size="lg"
                className="w-full sm:w-auto px-8 py-4 text-base"
                icon={<FileText className="w-5 h-5 text-slate-500" />}
                onClick={() => handleOpenModal('bottom_cta_doc')}
              >
                製品資料・仕様書を取り寄せる
              </Button>
            </div>
          </div>
        </section>
      </main>

      {/* Global Footer */}
      <Footer onOpenLeadModal={handleOpenModal} />

      {/* Lead Capture Modal */}
      <LeadFormModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        initialSource={modalSource}
      />
    </div>
  );
}
export default App;
